module.exports = __webpack_public_path__ + "static/mlh-trust-badge-2021-white-bcf8e5e6faf5f03f0f43ea24138238f4.svg";